import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ReviewTranslationToggle({
  review,
  showUntranslatedText,
  setShowUntranslatedText,
  onTrackInteraction = () => {}
}) {
  return review.isTranslated() ? /*#__PURE__*/_jsx(Text, {
    as: "small",
    children: /*#__PURE__*/_jsx(Flex, {
      display: "inline-flex",
      paddingBlockEnd: "200",
      flexDirection: "row",
      justifyContent: "end",
      alignItems: "center",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "marketplace-ui-reviews.translationDisclaimer_jsx",
        elements: {
          Link
        },
        options: {
          originalLanguage: LanguageNames[review.get('originalLanguage')],
          showUntranslatedText,
          onClick: () => {
            setShowUntranslatedText(!showUntranslatedText);
            onTrackInteraction({
              action: showUntranslatedText ? 'click show translated review' : 'click show untranslated review',
              section: 'review'
            });
          }
        }
      })
    })
  }) : null;
}